<div class="notification-modal">
  <div class="modal-content">
    <div class="modal-icon" [ngClass]="data.type">
      <mat-icon>{{ 
        data.type === 'success' ? 'check_circle_outline' : 
        (data.type === 'confirm' ? 'help_outline' : 
        (data.type === 'condolences' ? 'favorite' : 'info_outline')) 
      }}</mat-icon>
    </div>
    <h3>{{ data.title }}</h3>
    <p [innerHTML]="data.message"></p>
    <div class="modal-buttons" *ngIf="data.type === 'confirm'; else singleButton">
      <button mat-raised-button class="modal-button cancel" (click)="close()">
        No
      </button>
      <button mat-raised-button class="modal-button confirm" (click)="confirm()">
        Sí
      </button>
    </div>
    <ng-template #singleButton>
      <button mat-raised-button class="modal-button" (click)="close()">
        Aceptar
      </button>
    </ng-template>
  </div>
</div>